import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import TableIncomeAndExpense from '../../mainIncomAndExpenseWidgets/TableIncomeAndExpense'
import { getAllProjectAcc, searchAllProjectAcc } from '../../../redux/actions/dashboard'
import TableLoadingTemplate from '../../loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'
import notification from '../../../utils/notification'
import { SEARCH_ERR_MSG } from '../../../constants/msgText'
import { cloneDeep } from 'lodash-es'

export default function IncomeAndExpense({ setRequestBody = () => {} }) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    try {
      const response = await getAllProjectAcc(1, 5)
      setSchema(response)
      // setSchema(mockSchema)
    } catch (e) {
      console.log('error ', e)
      // setError({})
    }
    setIsLoading(false)
  }

  const handleSearch = async (pagenumber = 1, pagesize = 5, request, notSetBody) => {
    // console.log('handleSearch ', pagenumber, pagesize)
    setIsLoading(true)

    try {
      if (!notSetBody) {
        setRequestBody(request)
      }

      const response = await searchAllProjectAcc(pagenumber, pagesize, request)

      if (response) {
        var _schema = cloneDeep(schema)
        _schema.datas = response

        setSchema(_schema)
      }
    } catch (e) {
      // console.log('error ', e)
      // setError({})
      notification.open('success', {
        title: SEARCH_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
  }

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <Panel
          shaded
          collapsible
          defaultExpanded
          header={schema.header}
          bordered
          style={{ marginTop: 15 }}
        >
          <TableIncomeAndExpense schema={schema} loading={isLoading} onSearch={handleSearch} />
        </Panel>
      )}
    </>
  )
}
